import { AppData, Registry, Utils } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning";
import { Button, ButtonSmall, Icon } from "@lightningjs/ui-components";
import { AppSetup } from "../../lib/app-setup";
import { AppApiConfig } from "../../lib/app-api-config";

export interface MessagageBoxTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class MessagageBox

    extends Lightning.Component
    implements Lightning.Component<MessagageBoxTemplateSpec> {
    _index: number = -1
    _messageType: string = 'success' // success, warn, error
    enterAnimation!: any
    exitAnimation!: any

    _theme: Theme = {};

    static override _template(): Lightning.Component.Template<MessagageBoxTemplateSpec> {

        return {
            w: 650,
            h: 300,
            rect: true,
            color: 0xff222222,
            flex: { direction: 'column', alignItems: 'center', justifyContent: "space-between", padding: 20 },
            Title: {
                text: { text: 'Uh-Oh'}
            },
            Line: {
                w: (w) => w,
                h: 3,
                rect: true,
                color: 0xffffffff,
            },
            Message: {
                padding: 20,
                text: { text: 'Please unblock to play Content' }
            },
            Button: {
                type: Button,
                fixed: true,
                w:125,
                h:75,
                title: 'OK'
            }
        }
    }

    _getBgColor(type: string): any {
        if (type == 'error') {
            return 0xAAF13637
        } else if (type == 'warn') {
            return 0xAAF13637
        }
        return 0x88209F22
    }

    override _init() {
        const { appState, appConfig } = AppData as AppSetup
        const app = appState?.getApp();
        this._theme = (app?.themesObj as Theme) || {};
        const appApiConfig = appState?.getAppApiConfig()
        const apiConfig: AppApiConfig = appState?.getAppApiConfig()!
        const fontFamily = apiConfig.getTitleFontFamily()
        this._theme.gridfocuscolor = `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'
        this.tag('Title')?.patch({
            text: {
                fontFace: fontFamily
            }
        })
        this.enterAnimation = this.animation({
            duration: 0.25,
            stopMethod: 'immediate',
            actions: [
                { p: 'alpha', v: { 0: 0.001, 1: 1 } },
            ]
        })

        this.exitAnimation = this.animation({
            duration: 0.25,
            stopMethod: 'immediate',
            actions: [
                { p: 'alpha', v: { 0: 1, 1: 0.001 } },
            ]
        })

        // this.enterAnimation.on('finish', () => {
        //   Registry.setTimeout(() => {
        //     this.exitAnimation.start()
        //   }, 3000)
        // })

        this.exitAnimation.on('finish', () => {
            this.getAncestor(1)?.childList.remove(this)
        })

        this.enterAnimation.start()
    }

    override _getFocused() {
        const tts = 'Uh-Oh Please unblock to play Content' + '  ' + 'OK'
        const { platform } = AppData as AppSetup;
        platform?.textToSpeach(tts)
        return this.tag('Button')
    }

    override _handleKey(event) {
        return true
    }

    override _handleBack() {
        this.fireAncestors('$closeMessageBox')
    }

    override _handleEnter() {
        this.fireAncestors('$closeMessageBox')
    }
}
